import * as React from 'react';
import * as cn from 'classnames';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { Slide } from './Slide';
import { arrayToPairs } from './utils/arrayToPairs';
import { Text } from '../Text';
import { Container } from '../Container';
import { NBSP } from '../../constants/symbols';

import { ICardItem, ISelectedPublication } from './types';
import { IGetPublicationParams } from '../../types/redux';
import * as styles from './styles.css';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export interface IPublicationsProps {
  content: ICardItem[];
  getPublication(payload: IGetPublicationParams): void;
  selectPublication(articleId: number): ISelectedPublication;
}

export const Publications: React.FC<IPublicationsProps> = props => {
  const [isMount, setIsMount] = React.useState<boolean>(false);
  const [isSliderPaused, setSliderPause] = React.useState<boolean>(false);

  const contentRow = arrayToPairs<ICardItem>(props.content);
  const content = [...contentRow].concat(contentRow);

  return (
    <div className={styles['container']}>
      <Container>
        <div className={styles['title']}>
          <Text size="h2" bold>
            Циан широко представлен в{NBSP}СМИ
          </Text>
        </div>
        <div className={styles['subtext']}>
          <Text size="default">
            Наши отчеты и аналитика регулярно публикуются в ведущих российских СМИ. В{NBSP}общей сложности, мы{NBSP}
            поучаствовали в более чем 1{NBSP}600 публикациях
          </Text>
        </div>
      </Container>
      <ActionAfterViewed timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT} callback={() => setIsMount(true)}>
        <div className={styles['feed']}>
          <div
            className={cn(styles['feed-inner'], isMount && styles['animation'], isSliderPaused && styles['feed-pause'])}
          >
            {content.map((item, i) => {
              return (
                <div className={styles['slide']} key={`first_${i}`}>
                  <Slide
                    content={item}
                    setSliderPause={setSliderPause}
                    getPublication={props.getPublication}
                    selectPublication={props.selectPublication}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </ActionAfterViewed>
    </div>
  );
};

Publications.displayName = 'Publications';
